import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const CallModal = ({ isOpen, onClose, phone }) => {
  const { t } = useTranslation();

  // ✅ Esc ստեղնով փակելու հնարավորություն (Accessibility Best Practice)
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const goldColor = '#c5a059';
  const darkNavy = '#0f172a';

  return (
    <div
      className="liber-modal-overlay"
      onClick={onClose}
      role="presentation"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.9)',
        display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 100000,
        backdropFilter: 'blur(8px)'
      }}
    >
      <div
        className="liber-modal-card"
        onClick={e => e.stopPropagation()}
        role="dialog" // ✅ Lighthouse-ի պահանջը
        aria-modal="true" 
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          background: 'white', 
          padding: '40px 30px', 
          borderRadius: '24px',
          width: '320px', 
          textAlign: 'center', 
          boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
          border: `1px solid rgba(197, 160, 89, 0.2)`
        }}
      >
        {/* Զանգի Icon - aria-hidden, որպեսզի չկարդա որպես տեքստ */}
        <div style={{
            width: '60px', height: '60px', background: 'rgba(197, 160, 89, 0.1)',
            borderRadius: '50%', display: 'flex', alignItems: 'center', 
            justifyContent: 'center', margin: '0 auto 20px', color: goldColor, fontSize: '24px'
        }}>
            <FontAwesomeIcon icon={faPhone} aria-hidden="true" />
        </div>

        <h3 id="modal-title" style={{ color: darkNavy, marginBottom: '10px', fontSize: '20px', fontWeight: '800', textTransform: 'uppercase' }}>
            {t('contact_us_title')}
        </h3>
        
        <p id="modal-description" style={{ color: '#64748b', fontSize: '14px', marginBottom: '25px' }}>
            {t('contact_us_subtitle')}
        </p>
        
        {/* Սովորական Զանգ */}
        <a 
          href={`tel:${phone}`} 
          className="modal-call-option tel" 
          aria-label={`${t('call_button')}: ${phone}`} // ✅ Հստակ անուն սքրին ռիդերի համար
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
            padding: '16px', margin: '12px 0', borderRadius: '14px', 
            background: goldColor, 
            color: 'white', textDecoration: 'none', fontWeight: 'bold',
            transition: '0.3s', boxShadow: '0 4px 15px rgba(197, 160, 89, 0.3)'
          }}
        >
          <FontAwesomeIcon icon={faPhone} aria-hidden="true" /> 
          <span>{t('call_button')}</span>
        </a>
        
        {/* WhatsApp Զանգ */}
        <a 
          href={`https://wa.me/${phone?.replace(/\D/g, '')}`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="modal-call-option wa" 
          aria-label="Contact us on WhatsApp" // ✅ Հստակ անուն
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
            padding: '16px', margin: '12px 0', borderRadius: '14px', 
            background: darkNavy, 
            color: goldColor, 
            border: `1px solid ${goldColor}`,
            textDecoration: 'none', fontWeight: 'bold',
            transition: '0.3s'
          }}
        >
          <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" /> 
          <span>WHATSAPP</span>
        </a>

        {/* Փակելու կոճակ */}
        <button
          onClick={onClose}
          type="button"
          aria-label={t('cancel_btn') || "Close modal"} // ✅ Accessible name
          style={{ 
              marginTop: '20px', border: 'none', background: 'none', 
              color: '#475569', // ✅ Գույնը մի փոքր մուգացրի կոնտրաստի համար
              cursor: 'pointer', fontSize: '14px',
              textDecoration: 'underline'
          }}
        >
          {t('cancel_btn')}
        </button>
      </div>
    </div>
  );
};

export default CallModal;